import { getCompanyPublicKeyResult } from "./encryptForCompany";
import { handleCreate } from "./uploadFile";

/**
 * Szyfruje plik kluczem OBIEKTU i wgrywa go na serwer (przepływ jak w CreateDossierModal:
 * POST /keys/object → szyfrowanie po stronie klienta → /file/init + części + /file/confirm).
 *
 * Klucz obiektu owija klucz publiczny FIRMY — docs/model-kluczy-firmowych.md, inwariant I1.
 * Zastępuje `uploadProfileEncryptedFile`, które owijało go kluczem AKTYWNEGO PROFILU: taki
 * plik (umowa w rejestrze, faktura rejestrowa, szablon aktu, załącznik aktu) otwierała
 * WYŁĄCZNIE osoba, która go wgrała, a przy zmianie profilu znikał także jej samej.
 *
 * FAIL-CLOSED: brak aktywnego klucza firmy RZUCA `CompanyKeyMissingError`
 * (utils/encryptForCompany.ts) zamiast po cichu zapisać plik nieczytelny dla kancelarii.
 *
 * Zwraca FileUri + KeyId do podpięcia pod encję rejestru (umowa / faktura / szablon).
 */
export const uploadCompanyEncryptedFile = async (
  file: File,
): Promise<{ FileUri: string; KeyId: string }> => {
  const companyKey = await getCompanyPublicKeyResult();

  const result = await handleCreate([file], undefined, companyKey, true, true);

  if (!result?.[0]?.uri) {
    throw new Error("Nie udało się wgrać pliku.");
  }

  return { FileUri: result[0].uri, KeyId: result[0].keyId };
};

export default uploadCompanyEncryptedFile;
